/** Format weight fraction (0–1) as a human-readable percentage for ingredient lists. */
export function formatIngredientPercent(fraction: number, locale: string): string {
  const pct = fraction * 100
  const maximumFractionDigits = pct < 0.01 ? 4 : pct < 1 ? 3 : 2
  const formatted = pct.toLocaleString(locale, {
    maximumFractionDigits,
    minimumFractionDigits: 0,
  })
  return `${formatted}%`
}
